import { RadialBarChart, RadialBar, ResponsiveContainer, PolarAngleAxis } from 'recharts';

interface GaugeStatProps {
  label: string;
  percent: number;
  displayValue: string;
  height?: number;
}

export default function GaugeStat({ label, percent, displayValue, height = 150 }: GaugeStatProps) {
  const clamped = Math.max(0, Math.min(100, percent));
  const data = [{ value: clamped }];
  return (
    <div className="relative" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart
          data={data}
          startAngle={180}
          endAngle={0}
          innerRadius="130%"
          outerRadius="200%"
          cx="50%"
          cy="95%"
          barSize={14}
        >
          <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
          <RadialBar dataKey="value" background={{ fill: 'oklch(var(--background-200))' }} fill="oklch(var(--primary-500))" cornerRadius={7} />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="absolute inset-x-0 bottom-1 flex flex-col items-center pointer-events-none">
        <span className="text-lg font-bold text-foreground-900 font-heading">{displayValue}</span>
        <span className="text-[11px] text-foreground-400">{label}</span>
      </div>
    </div>
  );
}
